export default __webpack_public_path__ + "dc442ac987311f30a56192c4bf83b436.png";